import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { useMemo } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";

/**
 * Header
 */

type Props = {
  centrocusto: number[] | null;
  status: number | null;
  centrocustoDropDown: CentroCustoDropDown[];
  onCentroCustoChange: (centrocusto: number[] | null) => void;
  onStatusChange: (status: number | null) => void;
  onClear: () => void;

};

export const Header = ({
  centrocustoDropDown,
  centrocusto,
  onCentroCustoChange,
  onClear,
  onStatusChange,
  status,
}: Props) => {

  const statusOptions = useMemo(() => {
    return [
      { id: 2, title: "Todos" },
      { id: 0, title: "Em Aberto" },
      { id: 1, title: "Finalizado" },
    ];
  }, []);

  const selectedCentroCusto = useMemo(() => {
    if (!centrocusto || centrocusto.length === 0) return null;
    return centrocustoDropDown.filter((x) => centrocusto.includes(x.id));
  }, [
    centrocusto,
    centrocustoDropDown,
  ]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-row gap-6 items-center justify-center">
        <div className="w-[70%] flex flex-row justify-start gap-3">
          <div className="w-[70%]">
            <DefaultMultiAutocomplete
              label="Centro de Custo"
              value={selectedCentroCusto}
              options={centrocustoDropDown}
              getOptionLabel={(x) => x.title}
              getOptionKey={(x) => x.id}
              onChange={(x) => onCentroCustoChange(x !== null ? x.map((item) => item.id) : null)}
            />
          </div>

          <div className="w-[30%]">
            <DefaultAutocomplete
              label="Status"
              value={statusOptions.find((x) => x.id === status) ?? null}
              options={statusOptions}
              getOptionLabel={(x) => x.title}
              getOptionKey={(x) => x.id}
              onChange={(x) => onStatusChange(x !== null ? x.id : null)}
            />
          </div>
        </div>

        <div className="w-[30%] flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClear}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
